// BUG-523: wires the version watcher to the router. main.tsx calls this once in the browser.
import { createReloadGate } from './reloadGate'
import { createVersionWatcher, fetchLiveSha } from './versionWatch'

/** The slice of React Router's data router this needs (createBrowserRouter's return value). */
export interface RouterLike {
  state: { location: { pathname: string } }
  subscribe: (fn: (state: { location: { pathname: string } }) => void) => () => void
}

export interface InstallOptions {
  router: RouterLike
  /** The sha this bundle was built from; empty in the dev server, which then watches nothing. */
  buildSha: string
  win: Window
  doc: Document
  fetchImpl: typeof fetch
}

/** Starts watching for a new release; returns stop(). */
export function installAppUpdate({ router, buildSha, win, doc, fetchImpl }: InstallOptions): () => void {
  if (!buildSha) return () => {}
  // Which release this tab runs, for a quick check in devtools: document.documentElement.dataset.build
  doc.documentElement.dataset.build = buildSha

  const gate = createReloadGate({ reload: () => win.location.reload(), storage: () => win.sessionStorage })
  let path = router.state.location.pathname
  const unsubscribe = router.subscribe((state) => {
    const from = path
    path = state.location.pathname
    gate.onRouteChange(from, path)
  })
  const stopWatching = createVersionWatcher({
    buildSha,
    check: () => fetchLiveSha(fetchImpl),
    onNewVersion: gate.markPending,
    win,
    doc,
  })
  return () => {
    unsubscribe()
    stopWatching()
  }
}
